<template>
  <div v-if="BPRoute" class="routeinfos">
    <HomeHeader :image-path="BPRoute.MainPic" :small="true" />
    <div class="infos">
      <template>
        <h1 v-html="BPRoute[language].Titel" />
        <div class="properties">
          <div><img src="../assets/sternradfahrt_icon_tourenverlaufe.png" title="Länge der Tour">{{ BPRoute.laenge }}</div>
          <div><img src="../assets/sternradfahrt_dauer.png" title="Dauer der Tour">{{ BPRoute.dauer }}</div>
        </div>

        <a v-if="BPRoute.gpxdatei!='' && language == 'de'" class="button" @click="downloadgpxfile">GPX Datei herunterladen</a>
        <a v-if="BPRoute.gpxdatei!='' && language == 'pl'" class="button" @click="downloadgpxfile">Pobierz dane GPX</a>
        <a v-if="BPRoute.gpxdatei!='' && language == 'cz'" class="button" @click="downloadgpxfile">Stáhnout soubor GPX</a>

        <div v-html="BPRoute[language].Kurzbeschreibung" />
      </template>

      <div class="filter">
        <div class="filter-header">
          <div class="filter-button-container">
            <label v-if="language == 'de'" class="titel" @click="showfilter=!showfilter">Übersicht filtern  </label>
            <label v-if="language == 'pl'" class="titel" @click="showfilter=!showfilter">Filtruj zestawienie </label>
            <label v-if="language == 'cz'" class="titel" @click="showfilter=!showfilter">Filtrovat přehled </label>
          </div>

          <div class="sortierung" style="display: none">
            Sortieren nach
            <select v-model="sortingby">
              <option v-if="geolocationenabled" value="distance">Entfernung</option>
              <option value="Ort">Ort</option>
              <!--<option value="">Vorgeschlagene Route</option>-->
            </select>
          </div>
        </div>
        <div class="filter-selector" :class="{ open: showfilter }">
          <div class="closer">
            <span v-if="language == 'de'" @click="showfilter=!showfilter">minimieren  |  </span>
            <span v-if="language == 'pl'" @click="showfilter=!showfilter">Zmniejsz  |  </span>
            <span v-if="language == 'cz'" @click="showfilter=!showfilter">Minimalizovat |  </span>
            <span v-if="language == 'de'" @click="reset()">Filter entfernen</span>
            <span v-if="language == 'pl'" @click="reset()">Usuń filtr</span>
            <span v-if="language == 'cz'" @click="reset()">Odstranit filtr</span>
          </div>
          <div class="filter-ort" style="display: none">
            <label v-if="language == 'de'" class="ueberschrift">Ort</label>
            <label v-if="language == 'pl'" class="ueberschrift">Miejscowość</label>
            <label v-if="language == 'cz'" class="ueberschrift">Obec</label>
            <div v-for="city in BPfilteredCities" class="item">
              <label><input v-model="filtercity" type="checkbox" :value="city"> {{ city }}</label>
            </div>
          </div>
          <div class="filter-kategorie">
            <label v-if="language == 'de'" class="ueberschrift">Eigenschaften</label>
            <label v-if="language == 'pl'" class="ueberschrift">Właściwości</label>
            <label v-if="language == 'cz'" class="ueberschrift">Vlastnosti</label>
            <div class="item">
              <input id="start" v-model="filterkategorie" type="checkbox" name="kategorie" value="start">
              <label for="start" v-html="texte[language].start" />
            </div>
            <div class="item">
              <input id="reparatur" v-model="filterkategorie" type="checkbox" name="kategorie" value="reparatur">
              <label for="reparatur" v-html="texte[language].reparatur" />
            </div>
            <div class="item">
              <input id="imbiss" v-model="filterkategorie" type="checkbox" name="kategorie" value="imbiss">
              <label for="imbiss" v-html="texte[language].imbiss" />
            </div>
            <div class="item">
              <input id="samstag" v-model="filterkategorie" type="checkbox" name="kategorie" value="samstag">
              <label for="samstag" v-html="texte[language].samstag" />
            </div>
            <div class="item">
              <input id="sonntag" v-model="filterkategorie" type="checkbox" name="kategorie" value="sonntag">
              <label for="sonntag" v-html="texte[language].sonntag" />
            </div>
            <div class="item">
              <input id="parkplatz" v-model="filterkategorie" type="checkbox" name="kategorie" value="parkplatz">
              <label for="parkplatz" v-html="texte[language].parkplatz" />
            </div>
            <div class="item">
              <input id="ziel" v-model="filterkategorie" type="checkbox" name="kategorie" value="ziel">
              <label for="ziel" v-html="texte[language].ziel" />
            </div>
          </div>
        </div>
      </div>

      <div class="waypoints">
        <ul>
          <li v-for="waypoint in BPfilteredWaypoints" :key="waypoint.id">
            <table style="width: 100%">
              <tr>
                <td>
                  <router-link :to="{ name: 'waypoint', params: { waypointId: waypoint.id }}">
                    <template>
                      {{ waypoint.city }}, {{ waypoint[language].Titel }}
                    </template>

                    <div class="additional">
                      <div class="props">
                        <img v-if="waypoint.typ_start == 1" src="../assets/Start_orange.png" :title="texte[language].start">
                        <img v-if="waypoint.typ_reparatur == 1" src="../assets/Werkstatt_orange.png" :title="texte[language].reparatur">
                        <img v-if="waypoint.typ_stempeln == 1" src="../assets/Stempelstelle_orange.png" :title="texte[language].stempelstelle">
                        <img v-if="waypoint.typ_imbiss == 1" src="../assets/Imbiss_orange.png" :title="texte[language].imbiss">
                        <img v-if="waypoint.typ_rahmenprogramm == 1" src="../assets/Rahmenprogramm_orange.png" :title="texte[language].rahmenprogramm">
                        <img v-if="waypoint.typ_samstag == 1" src="../assets/Samstag_orange.png" :title="texte[language].samstag">
                        <img v-if="waypoint.typ_sonntag == 1" src="../assets/Sonntag_orange.png" :title="texte[language].sonntag">
                        <img v-if="waypoint.typ_parkplatz == 1" src="../assets/Parkplatz_orange.png" :title="texte[language].parkplatz">
                        <i v-if="waypoint.typ_ziel == 1" class="fa fa-flag-checkered " :title="texte[language].ziel" style="font-size: 20px;padding: 0 5px;box-sizing: border-box" />
                      </div>

                      <div v-if="codelist.indexOf(waypoint.alpha_code.toLowerCase()) != -1" style="margin-top: 5px;">
                        <img src="../assets/Stempelstelle_Haken_gruen.png" title="Abschnitt absolviert" style="width: 30px;vertical-align: middle">
                      </div>

                      <div v-if="geolocationenabled && waypoint.distance" class="distance" style="text-align:right;margin-left: auto;margin-top: 5px;">
                        <img src="./../assets/location.svg" style="height: 10px;">{{ waypoint.distance | round }}
                      </div>
                    </div>
                  </router-link>
                </td>
              </tr>
            </table>
          </li>
          <div style="clear: both" />
        </ul>
      </div>

      <div class="legende">
        <div class="leg-item">
          <img src="../assets/Start_orange.png" title="Startpunkt der Strecke">
          <label v-html="texte[language].start" />
        </div>
        <div class="leg-item">
          <img src="../assets/Werkstatt_orange.png" title="Reparaturservice vor Ort">
          <label v-html="texte[language].reparatur" />
        </div>
        <div class="leg-item">
          <img src="../assets/Stempelstelle_orange.png" title="Stempelmöglichkeit">
          <label v-html="texte[language].stempelstelle" />
        </div>
        <div class="leg-item">
          <img src="../assets/Imbiss_orange.png" title="Imbiss vor Ort">
          <label v-html="texte[language].imbiss" />
        </div>
        <div class="leg-item">
          <img src="../assets/Rahmenprogramm_orange.png" title="Rahmenprogramm vor Ort">
          <label v-html="texte[language].rahmenprogramm" />
        </div>
        <div class="leg-item">
          <img src="../assets/Samstag_orange.png" title="Teilnahme am Samstag">
          <label v-html="texte[language].samstag" />
        </div>
        <div class="leg-item">
          <img src="../assets/Sonntag_orange.png" title="Teilnahme am Sonntag">
          <label v-html="texte[language].sonntag" />
        </div>
        <div class="leg-item">
          <img src="../assets/Parkplatz_orange.png" title="Parkplatzmöglichkeit">
          <label v-html="texte[language].parkplatz" />
        </div>
        <div class="leg-item">
          <i class="fa fa-flag-checkered " title="Zielpunkt der Strecke" style="font-size: 20px;padding: 0 5px;box-sizing: border-box;" />
          <label style="margin-left: 5px;" v-html="texte[language].ziel" />
        </div>
      </div>

      <Punktkarte v-if="BPfilteredWaypoints.length" :waypoints="BPfilteredWaypoints" :gpxdatei="urlgpxdatei" />
    </div>
  </div>
</template>

<script type="text/babel">

import Backbutton from '../components/Backbutton'
import Punktkarte from '../components/Punktkarte'
import HomeHeader from '../components/HomeHeader'

import sortBy from 'lodash/sortBy'

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {

  //console.log(lat1,lon1,lat2,lon2);
  function deg2rad(deg) {
    return deg * (Math.PI / 180)
  }

  var R = 6371 // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1)  // deg2rad below
  var dLon = deg2rad(lon2 - lon1)
  var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)

  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  var d = R * c // Distance in km
  return d
}

export default {
  name: 'RouteView',
  components: {HomeHeader, Backbutton, Punktkarte},
  filters: {
    round: function (value) {
      if (!value) return ''
      return Math.floor(value) + ' km'
    },
  },
  props: ['routeId'],
  data: function () {
    return {
      showfilter: 0,
      filtercity: [],
      filterkategorie: [],
      filterneu: null,
      sortingby: 'Ort', // or distance
      texte: {
        de: {
          start: 'Startpunkt der Strecke',
          ziel: 'Zielpunkt der Strecke',
          reparatur: 'Reparaturservice vor Ort',
          stempelstelle: 'Stempelstelle',
          imbiss: 'Imbiss vor Ort',
          rahmenprogramm: 'Rahmenprogramm vor Ort',
          samstag: 'Teilnahme am Samstag',
          sonntag: 'Teilnahme am Sonntag',
          parkplatz: 'Parkplatzmöglichkeit',
        },
        pl: {
          start: 'Punkt początkowy trasy',
          ziel: 'Meta trasy',
          reparatur: 'Na miejscu serwis naprawczy',
          stempelstelle: 'Punkt z pieczątkami',
          imbiss: 'Na miejscu mała gastronomia',
          rahmenprogramm: 'Na miejscu program dodatkowy',
          samstag: 'Udział w sobotę',
          sonntag: 'Udział w niedzielę',
          parkplatz: 'Parking',
        },
        cz: {
          start: 'Start trasy',
          ziel: 'Cíl trasy',
          reparatur: 'Oprava a servis na místě',
          stempelstelle: 'Kontrolní Stanoviště',
          imbiss: 'Občerstvení na místě',
          rahmenprogramm: 'Rámcový program na místě',
          samstag: 'Účast v sobotu',
          sonntag: 'Účast v neděli',
          parkplatz: 'Možnost parkování',
        },
      },
    }
  },
  computed: {
    language: function () {
      return this.$root.$i18n.locale
    },
    codelist: function () {
      return this.$root.codelist
    },
    urlgpxdatei: function () {
      return process.env.VUE_APP_API_ENDPOINT + 'uploads/' + this.BPRoute.gpxdatei
    },
    geolocationenabled: function () {
      return this.$root.currentlocation.lat && this.$root.currentlocation.lon
    },
    BPRoute: function () {
      let self = this
      return this.$root.BPRoutes.find((item) => item.id === self.routeId)
    },
    BPfilteredWaypoints() {
      // ALLE: return this.$root.BPPoints
      let bproute = this.BPRoute
      let BPPoints = this.$root.BPPoints
      let self = this
      //console.log(bproute.Punkte)
      let list = []

      bproute.Punkte.map(function (value, key) {
        let ret = BPPoints.filter((item) => item.id == value)
        //console.log(ret);
        if (!ret[0]) {
          //console.log(ret)
          return
        }
        if (self.filtercity.length && !(self.filtercity.includes(ret[0]['city']))) {
          //console.log('nicht in Stadt: ' + ret)
          return
        }

        //console.log(( ret[0]['typ_gastronomie'] === '1' ) + ' ungleich ' + self.filterkategorie.includes('gastronomie') );
        //console.log(( ret[0]['typ_wohnhaus'] === '1' ) + ' ungleich ' + self.filterkategorie.includes('wohnhaus') );
        //console.log(( ret[0]['typ_museum'] === '1' ) + ' ungleich ' + self.filterkategorie.includes('museum') );
        //console.log('-------------------')
        if (self.filterkategorie.length
            && !(
              (self.filterkategorie.includes('start') && (ret[0]['typ_start'] === '1') == self.filterkategorie.includes('start')) ||
              (self.filterkategorie.includes('ziel') && (ret[0]['typ_ziel'] === '1') == self.filterkategorie.includes('ziel')) ||
              (self.filterkategorie.includes('reparatur') && (ret[0]['typ_reparatur'] === '1') == self.filterkategorie.includes('reparatur')) ||
              (self.filterkategorie.includes('stempeln') && (ret[0]['typ_stempeln'] === '1') == self.filterkategorie.includes('stempeln')) ||
              (self.filterkategorie.includes('rahmenprogramm') && (ret[0]['typ_rahmenprogramm'] === '1') == self.filterkategorie.includes('rahmenprogramm')) ||
              (self.filterkategorie.includes('samstag') && (ret[0]['typ_samstag'] === '1') == self.filterkategorie.includes('samstag')) ||
              (self.filterkategorie.includes('sonntag') && (ret[0]['typ_sonntag'] === '1') == self.filterkategorie.includes('sonntag')) ||
              (self.filterkategorie.includes('parkplatz') && (ret[0]['typ_parkplatz'] === '1') == self.filterkategorie.includes('parkplatz')) ||
              (self.filterkategorie.includes('imbiss') && (ret[0]['typ_imbiss'] === '1') == self.filterkategorie.includes('imbiss'))
            )
        ) {
          //console.log('nicht in kategorie: ' + ret)
          return
        }
        if (self.filterneu && (ret[0]['neu'] === '1') !== self.filterneu) {
          //console.log('nicht neu: ' + ret)
          return
        }

        let ort = ret[0]

        let distance = getDistanceFromLatLonInKm(self.$root.currentlocation.lat, self.$root.currentlocation.lon, ort['latitude'], ort['longitude'])

        ort['distance'] = distance

        list.push(ort)
        //console.log(value);
      })

      // soertieren
      if (this.sortingby == 'Titel')
        return sortBy(list, ['Titel'])

      if (this.sortingby == 'Ort')
        return sortBy(list, ['Ort'])

      if (this.sortingby == 'distance')
        return sortBy(list, ['distance'])

      return list

    },
    BPfilteredCities() {
      // ALLE: return this.$root.BPPoints
      let bproute = this.BPRoute
      let BPPoints = this.$root.BPPoints
      //console.log(bproute.Punkte)
      let list = []

      bproute.Punkte.map(function (ortsid, key) {
        let ret = BPPoints.filter((item) => item.id == ortsid)

        //console.log(ret);
        if (ret && ret[0]) {
          list.push(ret[0]['city'])
        }
        //console.log(value);

      })

      //doppeltes aussortieren
      function onlyUnique(value, index, self) {
        return self.indexOf(value) === index
      }

      var unique = list.filter(onlyUnique)

      return unique

    },
  },
  methods: {
    reset() {
      this.filterkategorie = []
      this.filterneu = null
      this.filtercity = []
    },
    downloadgpxfile() {
      window._paq.push(['trackEvent', 'GPX Datei', 'GPX Datei herunterladen', this.BPRoute.de.Titel, '1'])
      window.location = this.urlgpxdatei
    },
  },
}
</script>

<style scoped lang="scss">
.legende {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;

  .leg-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;

    @media screen and (max-width: 480px) {
      width: calc(100%);
    }

    img, i {
      width: 20px;
      margin-right: 5px;
    }
    label {
      font-weight: bold;
      font-size: 12px;
    }
  }
}
</style>
